import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppLockProvider } from './components/AppLock';
import { AppGate } from './AppGate';
import { registerSW } from 'virtual:pwa-register';
import './styles/base.css';
import './styles/components.css';
import './components/AppLock/applock.css';
import 'calc-controls/styles.css';
import 'calc-nav/styles.css';
import 'calc-sidebar/styles.css';
import '@ascend/about-modal/styles.css';

// Register service worker for offline support (vite-plugin-pwa, autoUpdate)
registerSW({
  onNeedRefresh() {
    // A new version is available — autoUpdate strategy applies it on reload
  },
  onOfflineReady() {
    // App is cached and ready to work offline
  },
});

// Global error handling
window.addEventListener('unhandledrejection', (event) => {
    console.error('[Absence Budget] Unhandled promise rejection:', event.reason);
  // Prevent default browser handling (which logs to console with stack noise)
  event.preventDefault();
});

window.addEventListener('error', (event) => {
  // Only handle genuine runtime errors, not resource load failures
  if (event.error) {
    console.error('[Absence Budget] Uncaught runtime error:', event.error);
  }
});

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    {/*
      VISUAL mode + deferred-encryption pattern (see components/AppLock/AppLockContext.tsx):
      the app stores user data in IndexedDB; visual mode adds a password gate for
      access protection without the high-risk IndexedDB encryption migration.
      AppGate renders Welcome/Setup/Lock screens or the unlocked App.
    */}
    <AppLockProvider>
      <AppGate />
    </AppLockProvider>
  </React.StrictMode>
);
